import React, { useState } from "react";
import { Button, message } from "antd";
import { ExportOutlined } from "@ant-design/icons";
import { CsvHeader, downloadCsv } from "../../utils/csv";

// fetches the rows to export only when clicked (so it always reflects the current filters and
// never exports a stale or half loaded prefetch), then downloads them as a csv
export const ExportButton = ({
  getCsv,
  filename,
}: {
  getCsv: () => Promise<{ headers: CsvHeader[]; rows: Record<string, any>[] }>;
  filename: () => string;
}) => {
  const [exporting, setExporting] = useState(false);

  const handleExport = async () => {
    setExporting(true);
    try {
      const { headers, rows } = await getCsv();
      if (rows.length === 0) {
        message.info("There is nothing to export for the current filters");
        return;
      }
      downloadCsv(headers, rows, filename());
    } catch (error) {
      console.error("Error exporting csv:", error);
      message.error("Export failed, please try again");
    } finally {
      setExporting(false);
    }
  };

  return (
    <Button icon={<ExportOutlined />} loading={exporting} onClick={handleExport}>
      Export
    </Button>
  );
};

export default ExportButton;
